const EventManager = function () {
    let self, internal, fn;

    self = this;

    internal = {
        listeners: {}
    };

    fn = {
        addListener (eventName, handler) {
            if (!internal.listeners[eventName]) {
                internal.listeners[eventName] = [];
            }

            internal.listeners[eventName].push(handler);
            return handler;
        },

        removeListener (eventName, handler) {
            const handlers = internal.listeners[eventName];
            let i;

            if (!handlers) {
                return;
            }

            for (i = handlers.length; i >= 0; i -= 1) {
                if (handlers[i] === handler) {
                    return handlers.splice(i, 1)[0];
                }
            }
        },

        emit (eventName) {
            const handlers = internal.listeners[eventName];
            const length = handlers ? handlers.length : null;
            let i = 0;

            if (!handlers || !length) {
                return;
            }

            while (i < length) {
                handlers[i++].apply(this, Array.prototype.slice.call(arguments, 1));
            }
        }
    };

    self.addListener = fn.addListener;
    self.removeListener = fn.removeListener;
    self.listeners = internal.listeners;
    self.emit = fn.emit;
};

export default new EventManager();



// WEBPACK FOOTER //
// ./assets/js/managers/event-manager.js